import Vue from 'vue'
import App from './App.vue'
import router from './router'
//引入复制粘贴的js

// Vue.use(Clipboard)
//按需导入的vant组件


import i18n from './Utils/lang_i18n/index'
import './assets/css/global.css' //引入公共css样式文件
//  import './assets/css/large.css';"
Vue.config.productionTip = false
new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
